<template>
  <div class="notice-module-wrapper">
    <div class="notice-line"><span class="notice-txt">通知</span><span class="notice-tip">*可拖动结果至画布的通知中</span></div>
    <table class="table-chaining">
      <thead style="height:35px">
        <tr>
          <th>通知人员</th>
          <th>通知方式</th>
        </tr>
      </thead>
      <tbody>
        <tr draggable v-for="(item, index) in noticeList" :key="index" @dragstart="(e)=>{dragstart(e,item)}">
          <!-- <td :class="`text`">{{item.notifyRole === 1?'疗程管理师、患者':item.notifyRole === 2?'疗程管理师':'患者'}}</td> -->
          <td :class="`text`">
            <p v-if="(item.notifyRole === 1)">疗程管理师、患者</p>
            <p v-else-if="(item.notifyRole === 2)">疗程管理师</p>
            <p v-else-if="(item.notifyRole === 3)">患者</p>
            <p @click="pushPacketClick" v-else-if="(item.notifyRole === 4)">患者-推送包</p>
          </td>

          <!-- <td :class="`text`">{{item.notifyRole === 1?'疗程管理师、患者':item.notifyRole === 2?'疗程管理师':'患者'}}</td> -->
          <td :class="`text`">{{item.notifyType === 1?'全病程房间':'短信'}}</td>
        </tr>
      </tbody>
    </table>
    <!-- 点击患者推送包出来的弹窗 -->
    <div class="secondary-box-two" v-if="secondSymptomShow">
      <div class="searchBox">
        <el-input class="searchBox_input" size="mini" placeholder="请输入关键字搜索" prefix-icon="el-icon-search" clearable
          v-model="searchResultOneSymptom" @input="searchGetMedicationSymptom">
        </el-input>
      </div>
      <div class="box_item">
        <el-scrollbar style="height:100%">
          <div class="message-item-box">
            <div class="message-content-box">
              <span :class="indexs == 0 ? 'curOne-sign' : 'curOne-sign'" v-for="(el,indexs) in drugListSymptom"
                :key="indexs" draggable @dragstart="(e)=>{dragstart(e,el)}">{{el.fieldName}}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="pagination">
        <el-pagination small background @size-change="handleSizeChangeSymptom"
          @current-change="handleCurrentChangeSymptom" :current-page.sync="searchFormSymptom.current"
          :page-size="searchFormSymptom.size" layout="total, sizes, prev, pager, next, jumper" :total="totalSymptom">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { listForDropList } from "../api/index";
export default {
  components: {
    draggable
  },
  data() {
    return {
      noticeList: [
        {
          id: "t01", // 节点编号，前端控制，用于连线
          nodeType: 4, // 1,"输入",2,"输出",3,"条件",4,"通知"
          notifyType: 1, // 1.全病程IM房间，2短信
          notifyRole: 1, // 1, "所有人";2, "个案管理师";3, "患者"
          render: 1
        },
        {
          id: "t02",
          nodeType: 4,
          notifyType: 1,
          notifyRole: 3,
          render: 1
        },
        {
          id: "t03",
          nodeType: 4,
          notifyType: 1,
          notifyRole: 2,
          render: 1
        },
        {
          id: "t04",
          nodeType: 4,
          notifyType: 1,
          notifyRole: 4,
          render: 1
        }
      ],
      searchResultOneSymptom: "", //二级弹框搜索值症状
      secondSymptomShow: false, //打卡用药
      drugListSymptom: [],
      searchFormSymptom: {
        size: 50,
        current: 1,
        planName: ""
        // isEnable: false
      },
      totalSymptom: 0
    };
  },
  created() {},
  methods: {
    dragstart(e, user) {
      //对接完数据后在这里处理最终需要拖入的数据格式,如下obj：
      // let obj = {
      //   nodeType: 4,
      //   notifyType: 1,
      //   notifyRole: 2, //根据选的内容动态去拿
      // };
      console.log(e, user, "aa");
      if (user.notifyRole == 4) {
        return false;
      }
      console.log(user, "user");
      e.dataTransfer.setData("user", JSON.stringify(user)); //obj
    },
    // 患者推送包
    searchGetMedicationSymptom() {
      this.getMedicationSymptom(this.pharmacyName, this.pharmacyCode);
    },
    /**
     * @description:  获取患者推送包数据
     * @param {*}
     * @return {*}
     */
    getMedicationSymptom(name, code) {
      this.searchFormSymptom.planName = this.searchResultOneSymptom;
      listForDropList(this.searchFormSymptom).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.totalSymptom = res.data.total;
            this.drugListSymptom = res.data.records.map(item => {
              let json = {};
              json.id = item.id;
              json.nodeType = 4;
              // json.fieldCode = code;
              json.fieldName = item.planName;
              // json.fieldLabel = `${name}:${item.planName}`;
              json.fieldLabel = item.planName;
              json.fieldValue = item.id;
              json.isSlect = false;
              json.refId = item.id;
              json.notifyType = 10;
              return json;
            });
          } else {
            this.totalSymptom = 0;
            this.drugListSymptom = [];
          }
        }
      });
    },
    handleSizeChangeSymptom(val) {
      this.searchFormSymptom.size = val;
      this.getMedicationSymptom(this.pharmacyName, this.pharmacyCode);
    },
    handleCurrentChangeSymptom(val) {
      this.searchFormSymptom.current = val;
      this.getMedicationSymptom(this.pharmacyName, this.pharmacyCode);
    },
    pushPacketClick() {
      this.secondSymptomShow = !this.secondSymptomShow;
      this.getMedicationSymptom();
    }
  }
};
</script>
<style lang="less" scoped>
.table-chaining {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center;
  border: 1px solid #f0f0f0;
  td.text,
  th.text {
    max-width: 50px;
    border: 1px solid #f0f0f0;
    color: #666;
    height: 30px;
    padding: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  th {
    background-color: #f0f0f0;
    width: 100px;
    text-align: center;
  }
  td {
    background-color: #ffffff;
  }
  tr {
    cursor: move;
  }
  th.oprate,
  td.oprate {
    width: 200px;
  }
  td {
    line-height: 30px;
    span {
      color: #1a7bfc;
      cursor: pointer;
      margin: 0 5px;
    }
  }
  .empty-tr {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 40px;
    span {
      white-space: nowrap;
      color: #999999;
    }
  }
}
.notice-module-wrapper {
  background-color: #f2f7fe;
  user-select: none;
  padding: 20px 10px;
  position: relative;
  .notice-line {
    padding-bottom: 6px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 10px;
  }
  .notice-txt {
    font-size: 12px;
    font-weight: 600;
    color: #1a7bfc;
  }
  .notice-tip {
    font-size: 12px;
    color: #999999;
  }
}
.secondary-box-two {
  width: 723px;
  height: 440px;
  padding: 12px 18px 22px 10px;
  background: #f2f7fe;
  overflow: hidden;
  position: absolute;
  right: 260px;
  top: -150px;
  z-index: 999;

  .searchBox {
    width: 436px;
    height: 24px;

    /deep/.el-input--suffix .el-input__inner {
      width: 100%;
      padding: 0 30px 0 30px;
      background: #ffffff;
      border: none;
      box-sizing: border-box;
    }
  }

  .box_item {
    width: 100%;
    height: 320px;
    margin-top: 20px;
  }

  .message-content-box {
    overflow: hidden;
    margin: 0 0 10px 0;
    cursor: move;

    span {
      display: inline-block;
      padding: 4px 7px;
      border-radius: 30px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 14px;
      margin: 0 10px 10px 0;
    }

    .curOne-sign {
      background: #fff;
      color: #333333;
    }

    .curTwo-sign {
      padding: 3px 6px;
      background: #fff;
      color: #333333;
      border: 1px solid #f0f0f0;
    }

    .active {
      background: #1a7bfc;
      color: #fff;
    }
  }

  .pagination {
    width: 90%;
    margin: auto;
    margin-top: 20px;
  }
}

/deep/.el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}

/deep/.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
</style>